import { render, staticRenderFns } from "./research-development-basic-info.vue?vue&type=template&id=0dbf5e35"
import script from "./research-development-basic-info.vue?vue&type=script&lang=js"
export * from "./research-development-basic-info.vue?vue&type=script&lang=js"
import style0 from "./research-development-basic-info.vue?vue&type=style&index=0&id=0dbf5e35&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports